











import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import CardBlamable from "../CardBlamable.vue";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import Order from "../../models/order/Order";
import OrderCardBasicData from "@/components/order/OrderCardBasicData.vue";
import OrderCardRates from "@/components/order/OrderCardRates.vue";
import OrderCardAdditionalInfos from "@/components/order/OrderCardAdditionalInfos.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {OrderCardAdditionalInfos, OrderCardRates, OrderCardBasicData, CardBlamable, AsiContentContainer}
})
export default class OrderTabDetails extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	@Emit('orderChanged')
	public orderChanged(event: Event): Event {
		return event;
	}

}
